export default {"src":"/_next/static/media/fiat-vnd.9eb6448d.svg","height":30,"width":30};